import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/sword/new/book/init', method: 'GET', params }, { interceptResultCode: false })
}

// 拉取预约人数
export const onNumberAPI = (params) => {
    return axios({ url: '/sword/new/book/number', method: 'GET', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/login/free/loginout', method: 'POST', params }, { interceptResultCode: false })
}

// 完成任务
export const onTaskAPI = (params) => {
    return axios({ url: '/sword/new/book/task', method: 'POST', params }, { interceptResultCode: false })
}

// 领取任务奖励
export const onTaskGetAPI = (params) => {
    return axios({ url: '/sword/new/book/task/get', method: 'POST', params }, { interceptResultCode: false })
}

// 祈愿侠客
export const onCollectAPI = (params) => {
    return axios({ url: '/sword/new/book/collect', method: 'POST', params }, { interceptResultCode: false })
}

// 领取收集奖励
export const onRewardAPI = (params) => {
    return axios({ url: '/sword/new/book/collect/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 填写邀请码
export const onHelpAPI = (params) => {
    return axios({ url: '/sword/new/book/help', method: 'POST', params }, { interceptResultCode: false })
}

// 查询新服角色
export const onShowAPI = (params) => {
    return axios({ url: '/sword/new/book/show', method: 'GET', params }, { interceptResultCode: false })
}

// 绑定新服角色
export const onBindAPI = (params) => {
    return axios({ url: '/sword/new/book/bind', method: 'POST', params }, { interceptResultCode: false })
}

// 查询角色
export const onGameServerAPI = (params) => {
    return axios({ url: '/game/server', method: 'GET', params }, { interceptResultCode: false })
}

// 绑定角色
export const onGameBindAPI = (params) => {
    return axios({ url: '/game/binds', method: 'POST', params }, { interceptResultCode: false })
}

// 领取奖励
export const onBookRewardAPI = (params) => {
    return axios({ url: '/sword/new/book/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 支付
export const onBuyAPI = (params) => {
    return axios({ url: '/sword/new/book/buy', method: 'POST', params }, { interceptResultCode: false })
}

// 订单查询
export const onBuyShowAPI = (params) => {
    return axios({ url: '/sword/new/book/buy/show', method: 'GET', params }, { interceptResultCode: false })
}

// codeId查询api
export const wechatInfoAPI = (params) => {
    return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false })
}

// 领取抽奖次数
export const onGetAPI = (data) => {
    return axios({ url: '/sword/new/book/lottery/get', method: 'POST', data }, { interceptResultCode: false })
}

// 抽奖
export const onLotteryAPI = (data) => {
    return axios({ url: '/sword/new/book/lottery', method: 'POST', data }, { interceptResultCode: false })
}

// 领取实物奖励填写地址
export const onAddressAPI = (data) => {
    return axios({ url: '/sword/new/book/address', method: 'POST', data }, { interceptResultCode: false })
}



// WEBPACK FOOTER //
// ./src/pages/hjwq/prebook/api.js